//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { formulaDetail } from '../../../server/oldformula/'

export default {
  name: 'PaO2FiO2ratio_info',
  data () {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: 'ed93ac9557619e840f8ae9b6c9e8e27e'
    }
  },
  components: {
  },
  created () {
    this.hideLoad()
    this.getFormulaDetail()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    async getFormulaDetail () {
      var params = {
        uuid: this.id
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain)
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pulm/PaO2FiO2ratio_info.vue